export default __webpack_public_path__ + "static/media/logo-demo7.7bc270aa.svg";